import { Page } from 'common-front/src/components/page/page';
import { FilterColumns } from 'common-front/src/filtersColumns/filtersColumns';
import { useHeavent } from 'common-front/src/hooks/useHeavent';
import { useTitle } from 'common-front/src/hooks/useTitle';
import { RichTableList } from 'common-front/src/richTable/richTableList';
import { WorkflowsWorkflowFragment } from 'common/src/generated/types';
import { useService } from 'common/src/util/dependencies/dependencies';
import { WorkflowsPaths } from 'common/src/util/paths/workflowsPaths';
import { DEFAULT_PAGINATION_LIMIT } from 'common/src/vo/pagination';
import { EventsRendering } from 'common/src/vo/rendering';
import {
    WorkflowsDefaultColumns,
    WorkflowsSegmentsService
} from 'common/src/vo/segments/workflowsSegmentsService';
import * as React from 'react';
import { useEventContext } from '../../events/show/eventContext';
import { executeWorkflowsQuery, executeWorkflowsWorkflowQuery } from '../../generated/graphqlHooks';
import { useLocalEventState } from '../../hooks/useLocalState';
import { WorkflowRowDropdown } from './workflowRowDropdown';
import { WorkflowsCells } from './workflowsCells';
import { WorkflowsHeader } from './workflowsHeader';

export const Workflows = () => {
    const {
        translate,
        params: { organizationId, eventId }
    } = useHeavent();
    const {
        event: { name: eventName }
    } = useEventContext();
    useTitle(`${eventName} ${translate('automatisations_60045')}`);
    const workflowsSegmentsService = useService(WorkflowsSegmentsService);
    const [columns, setColumns] = useLocalEventState('workflows.columns', [
        WorkflowsDefaultColumns.Name,
        WorkflowsDefaultColumns.State,
        WorkflowsDefaultColumns.CreatedBy
    ]);
    const [limit, setLimit] = useLocalEventState('workflows.limit', DEFAULT_PAGINATION_LIMIT);
    const [sort, setSort] = useLocalEventState('workflows.sort', null);
    const possibleColumns = React.useMemo(
        () => workflowsSegmentsService.getWorkflowsPossibleColumns(),
        []
    );

    return (
        <Page.Root>
            <WorkflowsHeader />

            <Page.Content>
                <FilterColumns
                    columns={columns}
                    columnsSearch={[]}
                    eventId={eventId}
                    filters={[]}
                    limit={limit}
                    loadDataList={executeWorkflowsQuery}
                    loadRow={executeWorkflowsWorkflowQuery}
                    organizationId={organizationId}
                    possibleColumns={possibleColumns}
                    predicates={[]}
                    rendering={EventsRendering.List}
                    setColumns={setColumns}
                    setLimit={setLimit}
                    setSort={setSort}
                    showEditColumns={true}
                    showEditMode={false}
                    showFilters={false}
                    showMassActions={false}
                    showRowDropdown={true}
                    showRowEdit={true}
                    showSearchColumns={false}
                    sort={sort}
                >
                    <RichTableList
                        getEditPath={(row: WorkflowsWorkflowFragment) =>
                            WorkflowsPaths.UPDATE({
                                organizationId,
                                eventId,
                                workflowId: row.id
                            })
                        }
                        renderCell={(column, row: WorkflowsWorkflowFragment) => (
                            <WorkflowsCells column={column} row={row} />
                        )}
                        renderRowDropdown={(row: WorkflowsWorkflowFragment, reload) => (
                            <WorkflowRowDropdown reload={reload} workflow={row} />
                        )}
                    />
                </FilterColumns>
            </Page.Content>
        </Page.Root>
    );
};
